import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { format, addMonths } from 'date-fns';
import Async from 'react-select/async';
import DatePicker from 'react-datepicker';
import { CalendarContainer } from 'react-datepicker';
import '../SearchPage/Calendar/ReactDatepicker.css'
import DatePickerWrapper from '../../components/Datepicker/DatepickerWrapper';

import { API } from '../../API';
import { toast } from 'react-toastify';
import { showRequestError } from '../../utils/requestError';
import './ReportAddPage.scss';

export function ReportAddPage() {
  const { t } = useTranslation();
  let navigate = useNavigate();

  const [values, setValues] = useState({
    name: '',
  });
  const [narrativeIDs, setNarrativeIDs] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [errors, setErrors] = useState({});

  function removeTimezoneAndSetMidnight(dateString) {
    const date = format(dateString, 'yyyy-LL-dd') + ' 00:00:00'
    return date;
  }

  const handleChange = (e) => {
    setValues((oldValues) => ({
      ...oldValues,
      [e.target.name]: e.target.value,
    }));
  };

  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      API.fetch('GET', `/API/v1/narratives?q=${inputValue}`).then((data) => {
        resolve(
          data.objects.map((narrative) => {
            return { value: narrative.id, label: narrative.name };
          }),
        );
      }).catch((error) => {
        showRequestError(error, t('Narratives'));
        resolve([]);
      });
    });

  const handleSubmit = (e) => {
    e.preventDefault();

    if(narrativeIDs.length === 0) {
      setErrors({ ...errors, cases: t('Please select at least one case') });
      return;
    }

    API.fetch('POST', `/API/v1/reports`, null, {
      name: values.name,
      parameters: {
        narrative_ids: narrativeIDs,
        start_date: startDate ? removeTimezoneAndSetMidnight(startDate) : null,
        end_date: endDate ? removeTimezoneAndSetMidnight(endDate) : null,
      },
    }).then(() => {
      toast.success(t('Report created'));
      navigate('/reports');
    }).catch((error) => showRequestError(error, t('Create report')));
  };

  const container = ({ children }) => {
    return (
      <div className='react-datepicker custom-datepicker'>
        <CalendarContainer>
          <div style={{ position: "relative" }}>{children}</div>
        </CalendarContainer>
      </div>
    )
  }

  return (
    <div>
      <div className="page-header">
        <div className="breadcrumb">
          <span>
            <Link to="/reports">{t('Reports')}</Link>
          </span>
          <span>{t('New')}</span>
        </div>
      </div>
      <div className="form-wrapper" translate="no">
        <form method="post" onSubmit={handleSubmit}>
          <div className="form-element">
            <label htmlFor="name">{t('Name')}</label>
            <input
              className=""
              id="name"
              name="name"
              type="text"
              onChange={handleChange}
              required
            />
          </div>

          <div
            className={errors.cases ? 'form-element error' : 'form-element'}
          >
            <label>{t('Narratives')}</label>
            <Async
              className="react-select-container"
              classNamePrefix="react-select"
              cacheOptions
              defaultOptions
              isMulti={true}
              placeholder={t('Select')}
              loadOptions={promiseOptions}
              name="narratives"
              onChange={(values) => setNarrativeIDs(values.map((v) => v.value))}
            />
            <div className="error-message">{errors.cases}</div>
          </div>
          <div className="form-element">
            <label>{t('Date range')}</label>
            <DatePickerWrapper
              onChange={(startDate, endDate) => {
                setStartDate(startDate);
                setEndDate(endDate);
              }}
              initStartDate={startDate}
              initEndDate={endDate}
            />
          </div>

          <div className="form-element">
            <div className="submit-wrapper">
              <input type="submit" value={t('Create')} />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
